import React from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50" data-testid="main-header">
      <div className="container-custom">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="font-heading font-bold text-xl text-[#1a1a1a]" data-testid="company-logo">
            AURUM PRINTS ASSOCIATES
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-testid="desktop-nav">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-medium text-gray-600 hover:text-[#003151] transition-colors"
              data-testid="nav-home"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium text-gray-600 hover:text-[#003151] transition-colors"
              data-testid="nav-about"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-medium text-gray-600 hover:text-[#003151] transition-colors"
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-sm font-medium text-gray-600 hover:text-[#003151] transition-colors"
              data-testid="nav-portfolio"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary rounded-md"
              data-testid="nav-contact-btn"
            >
              Get in Touch
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-600 hover:text-[#1a1a1a] transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden border-t border-gray-100 py-4 space-y-2" data-testid="mobile-nav">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-sm font-medium text-gray-600 hover:text-[#003151] py-2 transition-colors"
              data-testid="mobile-nav-home"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-600 hover:text-[#003151] py-2 transition-colors"
              data-testid="mobile-nav-about"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-600 hover:text-[#003151] py-2 transition-colors"
              data-testid="mobile-nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left text-sm font-medium text-gray-600 hover:text-[#003151] py-2 transition-colors"
              data-testid="mobile-nav-portfolio"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary w-full mt-4 rounded-md"
              data-testid="mobile-nav-contact-btn"
            >
              Get in Touch
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
